import { Component, OnInit, Input } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { TranslateService } from '@ngx-translate/core';

import { FormControl } from '../form-control.model';


import { DiffusionDaysService } from '../../../../../features/private-campaign/services/diffusionDays.service';
import { DateAdapter } from 'saturn-datepicker-v15';
import { UserAuthService } from '../../../../../services/user/user-auth.service';

@Component({
    selector: 'wncm-form-control-diffusion-settings',
    templateUrl: './form-control-diffusion-settings.component.html',
    styleUrls: [
        '../form-control.component.scss',
        './form-control-diffusion-settings.component.scss',
    ],
})
export class FormControlDiffusionSettingsComponent
    extends FormControlComponent
    implements OnInit
{
    public controls: { [key: string]: FormControl };

    public isDayFiltered = new FormControl('isDayFiltered');
    public isHourFiltered = new FormControl('isHourFiltered');
    public isWeatherFiltered = new FormControl('isWeatherFiltered');
    public isTempFiltered = new FormControl('isTempFiltered');;
    public stateWeekDays = false;
    public stateHour = false;
    public stateWeather = false;
    public stateTemperature = false;

    public displayWeather;

    constructor(
        public userService: UserAuthService,
        private translate: TranslateService,
        private adapter: DateAdapter<any>,
        public diffusionDay$: DiffusionDaysService
    ) {
        super();
    }

    @Input()
    weekDaysControl;

    @Input()
    indexSelected;

    @Input()
    beginHourControl;

    @Input()
    endHourControl;

    @Input()
    weatherControl;

    @Input()
    minTempControl;

    @Input()
    maxTempControl;

    /**
     * Si `true`le spot diffusera seul dans la boucle à la place de tous les autres
     */
    @Input()
    isLoopOverride?: FormControl;

    @Input()
    value;

    ngOnInit() {
        super.ngOnInit();
        this.isDayFiltered.setValue(false);
        this.isHourFiltered.setValue(false);
        this.isTempFiltered.setValue(false);
        this.isWeatherFiltered.setValue(false);

        if (this.weekDaysControl.value.length !== 0) {
            this.isDayFiltered.setValue(true);
            this.stateWeekDays = true;
        }
        if (this.beginHourControl.value && this.endHourControl.value) {
            this.isHourFiltered.setValue(true);
            this.stateHour = true;
        }

        if (this.maxTempControl.value && this.minTempControl.value) {
            this.isTempFiltered.setValue(true);
            this.stateTemperature = true;
        }
        if (this.weatherControl.value) {
            if (
                this.weatherControl.value !== '4' &&
                this.weatherControl.value !== '5'
            ) {
                this.displayWeather = true;
            }
            this.isWeatherFiltered.setValue(true);
            this.stateWeather = true;
        }

        this.isDayFiltered.valueChanges.subscribe(() => {
            if (this.isDayFiltered.value === true) {
                this.stateWeekDays = true;
            } else {
                this.stateWeekDays = false;
                this.weekDaysControl.setValue([]);
            }
        });

        this.isHourFiltered.valueChanges.subscribe(() => {
            if (this.isHourFiltered.value === true) {
                this.stateHour = true;
                this.beginHourControl.setValue('08:00');
                this.endHourControl.setValue('17:00');
            } else {
                this.stateHour = false;
                this.beginHourControl.setValue(null);
                this.endHourControl.setValue(null);
            }
        });

        this.isWeatherFiltered.valueChanges.subscribe(() => {
            if (this.isWeatherFiltered.value === true) {
                this.stateWeather = true;
                this.weatherControl.setValue(4);
            } else {
                this.stateWeather = false;
                this.weatherControl.setValue(null);
            }
        });

        this.isTempFiltered.valueChanges.subscribe(() => {
            if (this.isTempFiltered.value === true) {
                this.stateTemperature = true;
                this.minTempControl.setValue(15);
                this.maxTempControl.setValue(25);
            } else {
                this.stateTemperature = false;
                this.minTempControl.setValue(null);
                this.maxTempControl.setValue(null);
            }
        });

        this.diffusionDay$.getEnum();
    }

    changeWeekDay(event: any) {
        this.stateWeekDays = event.checked;
        this.stateWeekDays || this.weekDaysControl.setValue([]);
    }

    changeHour(event: any) {
        this.stateHour = event.checked;
        if (this.stateHour) {
            this.beginHourControl.setValue('12:00');
            this.endHourControl.setValue('15:00');
        } else {
            this.beginHourControl.setValue(null);
            this.endHourControl.setValue(null);
        }
    }

    changeWeather(event: any) {
        this.stateWeather = event.checked;
        this.stateWeather
            ? this.weatherControl.setValue(4)
            : this.weatherControl.setValue(null);
    }

    changeTemperature(event: any) {
        this.stateTemperature = event.checked;
        if (this.stateTemperature) {
            this.minTempControl.setValue(15);
            this.maxTempControl.setValue(25);
        } else {
            this.minTempControl.setValue(null);
            this.maxTempControl.setValue(null);
        }
    }
}
